
export enum LocalStorageProps {
   JIO = "jio",
   SHARE_VIEW_TYPE = "shareViewType",
   AUDIOSEXIST = "audiosExists",
   OTHERS_EXIST = "othersExists",
   VIDEOS_EXIST = "videosExists",
   IMGEXISTS = "imagesExists", 
   LAST_REFRESH_TIME = "lastRefreshTime",
   SHARE_PUBLIC_SORT = "sharePublicSort",
   DC_GROUP_CODE = "dcGroupCode",
   SHARED_FOLDER = "sharedFolder",
   CURRENT_TAB = "currentTab",
   BREADCRUMBS = "brdCrumbs",
   PROFILE_PHOTO = "profileIconPhotoPath",
   SINGLE_SHARED_OBJECT = "singleSharedObject",
   REFERRAL_DETAILS = "referral_details",
   TWOFA_ENABLED = "isTwoFAEnabled",
   MOVEMENT_TIME = 'lastUserMovementTime',
   SEARCH_KEY = "search_key",
   PROFILE_PHOTO_WITH_APIKEY = "profileIconPhotoPathWithApiKey", //This property is required to show profile icon on FAQ & how to videos
   RECOVER_DATA = "recoverData",
   RECOVER_DATA_MOBILE = "recoverDataMobile",
   RECOVER_DATA_UNMASKEMAIL = "recoverDataUnmaskEmail",
   RECOVER_DATA_ERROR = "recoverDataErrorScreen",
   FAMILY_SHARE_INVITE_DATA = "familyShareInviteData",
   BANNER_DETAILS = "bannerDetails",
   SHARE_IMGEXISTS = "shareImagesExists",
   SHARE_AUDIOSEXIST = "shareAudiosExists",
   SHARE_VIDEOS_EXIST = "shareVideosExists",
   SHARE_OTHERS_EXIST = "shareOthersExists",
   UNIV_SHARELINK_SESSION_ID = "univSharelinkSessionID",
   UNIV_SHARELINK_SHAREKEY = "univSharelinkShareKey",
   UNIV_SHARELINK_PASSWD = "univSharelinkPswd",
   PUBLIC_LINK_CREATOR = "publicLinkCreator",
   PEOPLE_TAB_SORT_TYPE = "peopleTabSort",
   PLACE_TAB_SORT_TYPE = "placeTabSort",
   REDIRECTION_URL = "requestedUrl",
   INVITE_URL = "inviteRedirectionUrl",
   INVITE_KEY = "inviteKey",
   STORAGE_PROVIDER_TYPE = "storageProviderType",
   UPLOAD_INITIATED_FOLDER = "folderDataInWhichUploadIsInitiated",
   PRIVATE_FOLDER_PASSWORD = "pfPassword",
   PRIVATE_FOLDER_KEY = "privateFolderKey",
   PRIVATE_FOLDER_ALLOW = "privateFolderAllow",
   SHARE_KEY = "shareKey",
   SHARD_KEY = "shardKey",
   BACKUP_DEVICE_DETAILS ='backupDeviceDetails',
   APPLE_DETAILS = 'appleDetails',
   STATUS_REQ_USER_ID = 'statusReqUserId',
   MEDIA_STREAM_TOKEN_TIME = 'MediaStreamTokenTime',
   BACKUP_FOLDER_KEY ="backupFolderKey",
   JIOID_SSO_TOKEN_VALIDATION_SUCCESS = "jioIdSSOTokenValidated", // these properties are being used for jio id login to communicate between parent and child windows
   JIOID_SSO_TOKEN_INVALID = "ssoTokenInvalid", // these properties are being used for jio id login to communicate between parent and child windows
   JIOMART_SSO_TOKEN_VALIDATION_SUCCESS = "jioMartSSOTokenValidated", // these properties are being used for jio mart login to communicate between parent and child windows
   JIOMART_SSO_TOKEN_INVALID = "ssoTokenInvalid", // these properties are being used for jio mart login to communicate between parent and child windows
   JIOID_LOGGEDOUT = "jioidlogoutSuccess",
   JIOID_LOGOUT_ERROR = "jioidlogoutError",
   JIOMART_TOKEN_DETAILS = "jiomartDetails", // this is used for storing the jiomart transaction id and token in local storage until login
   AI_SEARCH_TOGGLE_ENABLED = "aiSearchToggleEnabled",
   DOWNTIME_BANNER = "downTimeBanner",
   IOS_CLOUDBRIDGE_USER_ID = "iosCloudBridgeUserId",
   SEARCH_FEEDBACK_REQUEST_ID = "SearchFeedbackRequestId",
   JC_JWT = "jcJWT",
   IS_WAVE_EVENT = "isWaveEevent"
}